import script from "./HubBall.vue?vue&type=script&setup=true&lang=js"
export * from "./HubBall.vue?vue&type=script&setup=true&lang=js"

import "./HubBall.vue?vue&type=style&index=0&id=7d5a64dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5a64dd"]])

export default __exports__